// extracted by mini-css-extract-plugin
module.exports = {"link":"link-with-count_link__1cwrM","text":"link-with-count_text__2jtVf","count":"link-with-count_count__1d6mg"};